import type { InspectionErrand, Tenant } from '@pigello/pigello-matrix';
import type { TCustomList } from './types';
import { chunkIds } from '../utils';
import { getList } from '@/requests/api/get-list';
import { cloneDeep } from 'es-toolkit/compat';
import { getInspectionErrandConnectedObject } from '@/lib/inspection-errands/helpers/get-inspection-errand-connected-object';

export async function handleCustomInspectionErrandNestedCase(
  listResponse: TCustomList<InspectionErrand>
): Promise<TCustomList<InspectionErrand>> {
  const cloned = cloneDeep(listResponse);

  const connectedObjects = cloned.data
    .map(getInspectionErrandConnectedObject)
    .filter((el) => el !== null);

  const tenantIds = new Set(
    connectedObjects
      .map((el) => {
        if ('tenant' in el) {
          return el.tenant?.id;
        }

        return null;
      })
      .filter((el) => el !== null && el !== undefined)
  );

  const tenantIdsChunks = chunkIds(tenantIds);

  await Promise.all(
    tenantIdsChunks.map(async (chunk) => {
      try {
        const tenants = await getList<Tenant>({
          modelName: 'tenant',
          queryParams: {
            filters: {
              id: { __in: chunk },
            },
          },
        });

        const byTenantId = new Map<string, typeof connectedObjects>();
        for (const obj of connectedObjects) {
          if ('tenant' in obj && obj.tenant?.id) {
            const arr = byTenantId.get(obj.tenant.id) ?? [];
            arr.push(obj);
            byTenantId.set(obj.tenant.id, arr);
          }
        }
        for (const tenant of tenants.list) {
          byTenantId.get(tenant.id)?.forEach((obj) => {
            if ('tenant' in obj) obj.tenant = tenant;
          });
        }
      } catch (error) {
        // Ignore failed requests
        console.error(
          'failed to get tenants for inspections connected object',
          error
        );
      }
    })
  );

  return cloned;
}
